<template>
  <div class="modal-header" data-testid="components-modals-components-header-div">
    <div
      :class="[
        'modal-header__wrap',
        { 'modal-header__wrap--sub-title': subTitle },
      ]"
     data-testid="components-modals-components-header-div-2">
      <div data-testid="components-modals-components-header-div-3">
        <p
          :class="[
            'modal-header__title',
            { 'modal-header__title--mini': isTitleMini },
          ]"
         data-testid="components-modals-components-header-p">
          {{ title }}
        </p>
        <p v-if="subTitle" class="modal-header__sub-title" data-testid="components-modals-components-header-p-2">
          {{ subTitle }}
        </p>
      </div>

      <div class="modal-header__icons" data-testid="components-modals-components-header-div-4">
        <!--        <div v-if="history" @click="$emit('showHistory')" class="header-icon">-->
        <!--          <UiIcon @click="$emit('showHistory')" color="#292929" width="16" height="14" value="history" />-->
        <!--        </div>-->
        <div v-if="columns" class="header-icon" @click="$emit('showColumns')" data-testid="components-modals-components-header-div-5">
          <UiIcon
            color="#292929"
            width="16"
            height="14"
            value="columns"
            @click="$emit('showColumns')"
          data-testid="components-modals-components-header-ui-icon" />
        </div>
        <div v-if="options" class="header-icon" @click="$emit('showOptions')" data-testid="components-modals-components-header-div-6">
          <UiIcon
            color="#292929"
            width="16"
            height="14"
            value="options"
            @click="$emit('showOptions')"
          data-testid="components-modals-components-header-ui-icon-2" />
        </div>
        <div v-if="rawData" class="header-icon" @click="$emit('showRawData')" data-testid="components-modals-components-header-div-7">
          <UiIcon
            color="#292929"
            width="16"
            height="14"
            value="rawData"
            @click="$emit('showRawData')"
          data-testid="components-modals-components-header-ui-icon-3" />
        </div>

        <div
          class="h-[28px] w-[28px] rounded-full bg-[#EDEFF3] hover:bg-[#EDEFF3]/75 cursor-pointer flex justify-center items-center transition-opacity duration-300"
          @click="$emit('close')"
         data-testid="components-modals-components-header-div-8">
          <UiIcon color="#999999" width="17" height="17" value="close-v3" data-testid="components-modals-components-header-ui-icon-4" />
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import UiIcon from "@/components/ui/icon";

defineProps({
  close: {
    type: Boolean,
    default: false,
  },

  options: {
    type: Boolean,
    default: false,
  },

  history: {
    type: Boolean,
    default: false,
  },

  columns: {
    type: Boolean,
    default: false,
  },

  rawData: {
    type: Boolean,
    default: false,
  },

  title: {
    type: String,
    default: "",
  },

  isTitleMini: {
    type: Boolean,
    default: false,
  },

  subTitle: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="scss">
.modal-header {
  margin-bottom: 16px;

  &__title {
    font-family: "Source Sans Pro", sans-serif;
    display: block;
    overflow: hidden;
    font-size: 24px;
    white-space: nowrap;
    color: #000;
    font-weight: 600;
    line-height: 120%;
    text-overflow: ellipsis;

    &--mini {
      font-size: 20px;
      font-weight: 600;
    }
  }

  &__sub-title {
    overflow: hidden;
    font-size: 14px;
    color: #a6aeb8;
    font-weight: 400;
    line-height: 140%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-width: 0;
    margin-bottom: 3px;
    column-gap: 20px;

    > div:first-child {
      min-width: 0;
      flex: 1;
      overflow: hidden;
    }

    &--sub-title {
      align-items: flex-start;
    }
  }

  &__icons {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    column-gap: 12px;

    :deep(svg) {
      width: 16px;
      height: 14px;
    }
  }
}

.header-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  background: #edeff3;
  border-radius: 50%;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    background: #dce1e7;
  }
}
</style>
